import type { TimeOffPayload } from '~/lib/api/types'
import styles from './ooo-log.module.scss'

type Props = { periods: TimeOffPayload[] }

export function OooLog({ periods }: Props) {
  if (periods.length === 0) {
    return (
      <p className={styles.empty} aria-live="polite">
        No time off in this window.
      </p>
    )
  }

  return (
    <ol className={styles.list} aria-label="Time off log">
      {periods.map(p => (
        <li key={p.id} className={styles.row}>
          <span className={`${styles.range} mono`}>
            {formatRange(p.start_date, p.end_date)}
          </span>
          <span className={`${styles.kind} ${kindClass(p.kind)}`}>
            {p.kind}
          </span>
          {p.note && <span className={styles.note}>{p.note}</span>}
        </li>
      ))}
    </ol>
  )
}

function formatRange(start: string, end: string): string {
  if (start === end) return shortDate(start)
  return `${shortDate(start)}–${shortDate(end)}`
}

function shortDate(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number)
  const date = new Date(y as number, (m as number) - 1, d as number)
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}

function kindClass(kind: TimeOffPayload['kind']): string {
  switch (kind) {
    case 'vacation':
      return styles.kindVacation ?? ''
    case 'sick':
      return styles.kindSick ?? ''
    case 'holiday':
      return styles.kindHoliday ?? ''
    case 'other':
    default:
      return styles.kindOther ?? ''
  }
}
